// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"123":"52abadf8","716":"185ebb8f"}[chunkId] + ".chunk.js");